export const truncate = (text: string | undefined, maxLength: number) =>
  text && text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
